import { useTranslation } from "react-i18next";
import ErrorIcon from "@assets/Error.png";

interface ErrorDisplayProps {
  error: string;
}

const ErrorDisplay = ({ error }: ErrorDisplayProps) => {
  const { t } = useTranslation();

  return (
    <div className="w-full font-outfit flex justify-center items-center h-[60vh]">
      <div className="flex justify-center items-center flex-col space-y-[24px]">
        <div className="w-[80px] h-[80px]">
          <img
            src={ErrorIcon}
            className="w-full h-full"
            alt={t("home.alt_text.error_icon")}
          />
        </div>
        <div className="flex flex-col space-y-2">
          <p className="text-center text-[18px] font-semibold leading-[127%]">
            {t("home.error")}
          </p>
          <p className="px-4 text-center text-[18px] font-normal leading-[127%]">
            {error}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;
